import { KEY_REDUCER_SEARCH } from "./constants";


export const selectorSearchResultsDictionary = (state) => {
  return state[KEY_REDUCER_SEARCH].searchDictionary;
};

export const selectorSearchParamsDictionary = (state) => {
  return state[KEY_REDUCER_SEARCH].searchParamsDictionary;
};

export const selectorSearchResults = (state) => state[KEY_REDUCER_SEARCH].search;
export const selectorSearchParams = (state) => state[KEY_REDUCER_SEARCH].searchParams;
export const selectorSearchQueryLangs = (state) => state[KEY_REDUCER_SEARCH].searchQueryLangs;
export const selectorLocalSearchParams = (state) => state[KEY_REDUCER_SEARCH].localSearchParams;
export const selectorLocalSearchResults = (state) => state[KEY_REDUCER_SEARCH].localSearch;
export const selectorSearchQuery = (state) => state[KEY_REDUCER_SEARCH].searchQuery;
export const selectorSearchShortcuts = (state) => state[KEY_REDUCER_SEARCH].shortcuts;
export const selectorSearchShortcutContent = (state) => state[KEY_REDUCER_SEARCH].shortcutContent;
export const selectorSearchLang = (state) => state[KEY_REDUCER_SEARCH].searchLang;

export const selectorSearchFilter = (state) => state[KEY_REDUCER_SEARCH].searchFilter;

export const selectorSearchHistory = (state) => state[KEY_REDUCER_SEARCH].searchHistory;

// These electors are for Main app only so far
export const selectorSearchBookListSuppressed = (state) => {
  return state[KEY_REDUCER_SEARCH].searchBookListSuppressed;
};
export const selectorQueryBooksSearch = (state) => {
  return state[KEY_REDUCER_SEARCH].searchNeedle;
};

export const selectorSearchRightPanelPosition = (state) => {
  return state[KEY_REDUCER_SEARCH].rightPanelPosition;
};

export const selectorSearchClearMarkBookId = (state) => {
  return state[KEY_REDUCER_SEARCH].searchClearMarkBookId;
};
